import React, { useState } from "react";
import { qris } from "../assets";
import { useNavigate } from "react-router-dom";
import { postPayment } from "../constants";

const PaymentMethod = ({ setStep, setLoading, packageId, couponCode }) => {
  const user = JSON.parse(localStorage.getItem("user_info"));
  const token = user.access_token;
  const [isQris, setIsQris] = useState(false);
  const navigate = useNavigate();

  const handleOnClick = (e) => {
    e.preventDefault();
    postPayment(
      token,
      {
        coupon_code: couponCode,
        package_interval_id: packageId,
      },
      setLoading,
      navigate
    );
  };
  return (
    <div className="flex flex-col w-full h-full justify-between items-start bg-white text-black p-8 gap-10">
      <div className="flex flex-col w-full gap-5 h-full">
        <div className="text-[32px] font-bold">Payment Method</div>
        <div className="flex flex-row gap-10 w-full justify-between h-full border rounded-lg">
          <div
            className={`flex flex-col rounded-lg border w-full h-full p-8 gap-5 divide-y-2`}
          >
            <div className="flex flex-row w-full justify-between items-center">
              <img src={qris} alt="" />
              <input
                type="radio"
                className="border-black border-2 cursor-pointer"
                value={isQris}
                onClick={() => setIsQris(!isQris)}
                checked={isQris}
              />
            </div>
            <div className="flex gap-3 flex-col pt-5">
              <div className="font-semibold text-[24px]">
                Payment Guidelines
              </div>
              <ol type="1" className="list-decimal px-5">
                <li>Scan or screenshoot QR code</li>
                <li>
                  Open bank/e-wallet application (Gojek, OVO, DANA, QRIS, BCA,
                  etc)
                </li>
                <li>Choose 'Pay' or 'Scan'</li>
                <li>Upload QR code screenshoot</li>
                <li>Input your PIN code</li>
                <li>If the payment success, you will get receipt email</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-row justify-between items-center w-full gap-20 md:gap-0">
        <div
          className="flex text-center w-[200px] py-2 border border-primary text-primary items-center justify-center rounded-md shadow-lg cursor-pointer"
          onClick={() => setStep(1)}
        >
          Back
        </div>
        <div
          className={`flex text-center w-[200px] py-2 border ${
            isQris
              ? "bg-primary cursor-pointer"
              : "bg-gray-200 cursor-not-allowed"
          } text-white items-center justify-center rounded-md shadow-lg `}
          onClick={(e) => {
            if (isQris) {
              setLoading(true);
              handleOnClick(e);
            }
          }}
        >
          Next
        </div>
      </div>
    </div>
  );
};

export default PaymentMethod;
